import { render, staticRenderFns } from "./usuario_2fa.vue?vue&type=template&id=7247d887&"
import script from "./usuario_2fa.vue?vue&type=script&lang=js&"
export * from "./usuario_2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports